import Vue from "vue";
import Router from "vue-router";
import Home from "./../views/Home.vue";
import {
  APPLICATION_GUIDE_PAGE,
  CONTACT_PAGE,
  EXAMPLE_360_PAGE,
  HOME_PAGE,
  INFO_PAGE,
  LOGIN_PAGE,
  REGISTER_PAGE,
  SIGNS_QUESTIONS_PAGE,
  SINGLE_TEST_PAGE,
  TESTS_PAGE,
} from "./routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: HOME_PAGE,
      component: Home,
    },
    {
      path: "/application-guide",
      name: APPLICATION_GUIDE_PAGE,
      component: () =>
        import(
          /* webpackChunkName: "application-guide" */ "./../views/ApplicationGuide.vue"
        )
    },
    {
      path: "/login",
      name: LOGIN_PAGE,
      component: () =>
        import(/* webpackChunkName: "login" */ "./../views/Login.vue"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/register",
      name: REGISTER_PAGE,
      component: () =>
        import(/* webpackChunkName: "register" */ "./../views/Register.vue"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/examples/:number",
      name: EXAMPLE_360_PAGE,
      component: () =>
        import(/* webpackChunkName: "examples" */ "./../views/Guide.vue"),
      meta: {
        auth: true,
        disableChat: true,
      },
    },
    {
      path: "/contact",
      name: CONTACT_PAGE,
      component: () =>
        import(/* webpackChunkName: "contact" */ "./../views/Contact.vue"),
    },
    {
      path: "/tests",
      name: TESTS_PAGE,
      component: () =>
        import(/* webpackChunkName: "tests" */ "./../views/Tests.vue"),
      meta: {
        auth: true,
        disableChat: true,
      },
    },
    {
      path: "/traffic-signs",
      name: SIGNS_QUESTIONS_PAGE,
      component: () =>
        import(/* webpackChunkName: "signs" */ "./../views/SignsQuiz.vue"),
      meta: {
        auth: true,
        disableChat: true,
      },
    },
    {
      path: "/info",
      name: INFO_PAGE,
      component: () =>
        import(/* webpackChunkName: "info" */ "./../views/Info.vue"),
      meta: {
        disableChat: true,
      },
    },
    {
      path: "/test/:testId",
      name: SINGLE_TEST_PAGE,
      component: () =>
        import(/* webpackChunkName: "test" */ "./../views/Test.vue"),
      meta: {
        auth: true,
        disableChat: true,
      },
    },
  ],
});

router.goToHomePage = () => {
  if (router.currentRoute.name === HOME_PAGE) {
    return;
  }
  router.push({
    name: "home",
  });
};

router.goToLastRequestedPage = () => {
  let lastRequested = localStorage.getItem("lastRequestedRoute") || HOME_PAGE;
  let lastRequestedRouteParams = JSON.parse(
    localStorage.getItem("lastRequestedRouteParams") || "{}"
  );
  router.push({
    name: lastRequested,
    params: lastRequestedRouteParams,
  });
};

router.beforeEach((to, from, next) => {
  const isAuthorized = !!localStorage.getItem("token");
  if (!to.meta.auth && to.meta.auth !== false) {
    return next();
  }
  if (!to.meta.auth) {
    return isAuthorized ? next({ name: from ? from.name : HOME_PAGE }) : next();
  }

  if (!isAuthorized) {
    localStorage.setItem("lastRequestedRoute", to.name);
    localStorage.setItem("lastRequestedRouteParams", JSON.stringify(to.params));
    return next({
      name: "login",
    });
  }
  return next();
});

router.afterEach(function(to) {
  const displayChat = to.meta.disableChat !== true;
  document.addEventListener("tidioChat-ready", () => {
    !displayChat && Vue.prototype.$tidioChatApi.hide();
  });
  Vue.prototype.$tidioChatApi &&
    Vue.prototype.$tidioChatApi.display(displayChat);
});

export default router;
